import { StyledLoader, StyledStripes } from './Loader.style';

interface LoaderProps {
  color?: string;
  size?: number;
  className?: string;
}

export function Loader(props: LoaderProps) {
  const { color, size = 32, className } = props;

  return (
    <StyledLoader className={className} color={color}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 31 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M1.56039 32C0.980553 32 0.551712 31.8188 0.273872 31.4564C-0.0039691 31.094 -0.0704093 30.6229 0.074551 30.043L7.50377 1.19592C7.75745 0.398641 8.25273 0 8.98961 0C9.56945 0 9.9983 0.187241 10.2761 0.561722C10.5661 0.924123 10.6204 1.3892 10.4392 1.95696L3.04624 30.8041C2.8288 31.6014 2.33352 32 1.56039 32Z'
          fill='currentColor'
        />

        <g transform='translate(0, -92)'>
          <StyledStripes
            d='M14.8701 26.4553C13.9037 26.4553 13.4205 25.9721 13.4205 25.0057V24.0997C13.4205 23.1574 13.9037 22.6863 14.8701 22.6863H15.7399C16.658 22.6863 17.117 23.1574 17.117 24.0997V25.0057C17.117 25.9721 16.658 26.4553 15.7399 26.4553H14.8701ZM14.8701 14.496C13.9037 14.496 13.4205 14.0128 13.4205 13.0464V12.1404C13.4205 11.1982 13.9037 10.7271 14.8701 10.7271H15.7399C16.658 10.7271 17.117 11.1982 17.117 12.1404V13.0464C17.117 14.0128 16.658 14.496 15.7399 14.496H14.8701Z'
            fill='currentColor'
          />
        </g>

        <g transform='translate(0, -69)'>
          <StyledStripes
            d='M14.8701 26.4553C13.9037 26.4553 13.4205 25.9721 13.4205 25.0057V24.0997C13.4205 23.1574 13.9037 22.6863 14.8701 22.6863H15.7399C16.658 22.6863 17.117 23.1574 17.117 24.0997V25.0057C17.117 25.9721 16.658 26.4553 15.7399 26.4553H14.8701ZM14.8701 14.496C13.9037 14.496 13.4205 14.0128 13.4205 13.0464V12.1404C13.4205 11.1982 13.9037 10.7271 14.8701 10.7271H15.7399C16.658 10.7271 17.117 11.1982 17.117 12.1404V13.0464C17.117 14.0128 16.658 14.496 15.7399 14.496H14.8701Z'
            fill='currentColor'
          />
        </g>

        <g transform='translate(0, -46)'>
          <StyledStripes
            d='M14.8701 26.4553C13.9037 26.4553 13.4205 25.9721 13.4205 25.0057V24.0997C13.4205 23.1574 13.9037 22.6863 14.8701 22.6863H15.7399C16.658 22.6863 17.117 23.1574 17.117 24.0997V25.0057C17.117 25.9721 16.658 26.4553 15.7399 26.4553H14.8701ZM14.8701 14.496C13.9037 14.496 13.4205 14.0128 13.4205 13.0464V12.1404C13.4205 11.1982 13.9037 10.7271 14.8701 10.7271H15.7399C16.658 10.7271 17.117 11.1982 17.117 12.1404V13.0464C17.117 14.0128 16.658 14.496 15.7399 14.496H14.8701Z'
            fill='currentColor'
          />
        </g>

        <g transform='translate(0, -23)'>
          <StyledStripes
            d='M14.8701 26.4553C13.9037 26.4553 13.4205 25.9721 13.4205 25.0057V24.0997C13.4205 23.1574 13.9037 22.6863 14.8701 22.6863H15.7399C16.658 22.6863 17.117 23.1574 17.117 24.0997V25.0057C17.117 25.9721 16.658 26.4553 15.7399 26.4553H14.8701ZM14.8701 14.496C13.9037 14.496 13.4205 14.0128 13.4205 13.0464V12.1404C13.4205 11.1982 13.9037 10.7271 14.8701 10.7271H15.7399C16.658 10.7271 17.117 11.1982 17.117 12.1404V13.0464C17.117 14.0128 16.658 14.496 15.7399 14.496H14.8701Z'
            fill='currentColor'
          />
        </g>

        <g transform='translate(0, 23)'>
          <StyledStripes
            d='M14.8701 26.4553C13.9037 26.4553 13.4205 25.9721 13.4205 25.0057V24.0997C13.4205 23.1574 13.9037 22.6863 14.8701 22.6863H15.7399C16.658 22.6863 17.117 23.1574 17.117 24.0997V25.0057C17.117 25.9721 16.658 26.4553 15.7399 26.4553H14.8701ZM14.8701 14.496C13.9037 14.496 13.4205 14.0128 13.4205 13.0464V12.1404C13.4205 11.1982 13.9037 10.7271 14.8701 10.7271H15.7399C16.658 10.7271 17.117 11.1982 17.117 12.1404V13.0464C17.117 14.0128 16.658 14.496 15.7399 14.496H14.8701Z'
            fill='currentColor'
          />
        </g>

        <StyledStripes
          d='M14.8701 26.4553C13.9037 26.4553 13.4205 25.9721 13.4205 25.0057V24.0997C13.4205 23.1574 13.9037 22.6863 14.8701 22.6863H15.7399C16.658 22.6863 17.117 23.1574 17.117 24.0997V25.0057C17.117 25.9721 16.658 26.4553 15.7399 26.4553H14.8701ZM14.8701 14.496C13.9037 14.496 13.4205 14.0128 13.4205 13.0464V12.1404C13.4205 11.1982 13.9037 10.7271 14.8701 10.7271H15.7399C16.658 10.7271 17.117 11.1982 17.117 12.1404V13.0464C17.117 14.0128 16.658 14.496 15.7399 14.496H14.8701Z'
          fill='currentColor'
        />

        <path
          d='M28.9505 32C28.1774 32 27.6821 31.6014 27.4647 30.8041L20.0717 1.95696C19.8905 1.3892 19.9388 0.924123 20.2167 0.561722C20.5066 0.187241 20.9415 0 21.5213 0C22.2582 0 22.7535 0.398641 23.0072 1.19592L30.4364 30.043C30.5813 30.6229 30.5149 31.094 30.2371 31.4564C29.9592 31.8188 29.5304 32 28.9505 32Z'
          fill='currentColor'
        />
      </svg>
    </StyledLoader>
  );
}
